import { NoSsr } from '@mui/material';
import type { IPlansComponentProps } from '@on3/ui-lib/api/schema/custom-contracts';
import { useAuth, useSite } from '@on3/ui-lib/index';

import { FrequentQuestions } from './FrequentQuestions';
import { JoinFansiteMarketing } from './JoinFansiteMarketing';
import { JoinForumMarketing } from './JoinForumMarketing';
import styles from './JoinPage.module.scss';
import { MembersHeader } from './MembersHeader';
import { On3AppPromo } from './On3AppPromo';
import { PerkChecklist } from './PerkChecklist/PerkChecklist';

export const JoinPage = ({ siteDetails }: IPlansComponentProps) => {
  const {
    siteBullets,
    genericAssetOne,
    genericDescription,
    genericTitle,
    forumsAssetOne,
    forumsAssetTwo,
    forumsDescription,
    forumsTitle,
  } = siteDetails || {};

  const { currentSite } = useSite();

  const { user } = useAuth();
  const teamName =
    currentSite?.organization?.knownAs ??
    currentSite?.organization?.name ??
    currentSite?.name ??
    'On3';

  const mascot = currentSite?.organization?.mascot || '';
  const isTeam = currentSite?.isTeam;
  const primaryForumTitle = currentSite?.primaryForum?.title;
  const subHeaderText = isTeam
    ? `Trusted news and analysis from ${teamName} insiders`
    : 'Trusted news and analysis from On3 insiders';
  const showFormMarketing = !!isTeam && !!forumsAssetOne && !!forumsAssetTwo;
  const showFansiteMarketing = !!isTeam && !!genericAssetOne;

  const hasSubscription = user?.has;

  return (
    <div className={styles.joinPageWrapper}>
      <div className={styles.joinPageContainer}>
        {!hasSubscription ? (
          <>
            <header className={styles.header}>
              <h1 className={styles.headerText}>
                <span>{`Unlock the Best of ${teamName}`}</span>
                <span>{mascot}</span>
              </h1>
              <span className={styles.subheader}>{subHeaderText}</span>
            </header>
            <div className={styles.pianoContainer}>
              <NoSsr>
                <div className={styles.pianoManualBlock}>
                  <div id="annualOffer" />
                  <div id="monthlyOffer" />
                  <div id="premium" />
                </div>
              </NoSsr>

              <div className={styles.perksContainer}>
                <PerkChecklist siteBullets={siteBullets} />
              </div>
            </div>
          </>
        ) : (
          <MembersHeader />
        )}

        {showFormMarketing && (
          <JoinForumMarketing
            assetOne={forumsAssetOne}
            assetTwo={forumsAssetTwo}
            description={forumsDescription}
            forumsTitle={forumsTitle}
            primaryForumTitle={primaryForumTitle}
          />
        )}
        <On3AppPromo />
        {showFansiteMarketing && (
          <JoinFansiteMarketing
            asset={genericAssetOne}
            description={genericDescription}
            title={genericTitle}
          />
        )}
        <FrequentQuestions />
      </div>
    </div>
  );
};
